import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const MemoryStepThreeExtraCollections = ({
  getCollectionsByGroupId,
  hasLoaded,
  memoryStepThreeExtraCollections,
  memoryStepThreeExtraCurrency,
  pageCount,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="memory-collections-container--step-three-extra"
      collectionsPath={paths.MEMORY_STEP_THREE_EXTRA_COLLECTIONS}
      currency={memoryStepThreeExtraCurrency}
      getCollectionsByGroupId={getCollectionsByGroupId}
      hasLoaded={hasLoaded}
      items={memoryStepThreeExtraCollections}
      levelsPath={paths.MEMORY_STEP_THREE_EXTRA_LEVELS}
      pageCount={pageCount}
      title={messages.game.memory}
    />
  );
};

MemoryStepThreeExtraCollections.propTypes = {
  getCollectionsByGroupId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  memoryStepThreeExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  memoryStepThreeExtraCurrency: PropTypes.shape({}).isRequired,
  pageCount: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.memoryStepThreeExtraCollections.getHasLoaded(state),
  memoryStepThreeExtraCurrency: selectors.memoryStepThreeExtraCollections.getCurrencyData(
    state
  ),
  memoryStepThreeExtraCollections: selectors.memoryStepThreeExtraCollections.getCollectionsData(
    state
  ),
  pageCount: selectors.memoryStepThreeExtraCollections.getPageCount(state),
});

const mapDispatchToProps = {
  ...actions.memoryStepThreeExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(MemoryStepThreeExtraCollections);
